"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.GENERIC_ERROR_MSG = void 0;
var GENERIC_ERROR_MSG = "Try refreshing the page.";
exports.GENERIC_ERROR_MSG = GENERIC_ERROR_MSG;